import styled, { css } from 'styled-components'
import Screenshot from './screenshot'

export default styled.div`
    background-position: right center;
    background-repeat: no-repeat;
    background-size: auto 100%;
    height: 516px;
    flex-shrink: 0;
    perspective: 1000px;
    position: relative;
    width: 570px;

    ${(props) =>
        props.desktop
            ? css`
                  background-image: url('/static/img/app_landing/computer.svg');
                  transform: scaleX(${(props) => (props.right ? 1 : -1)});

                  ${Screenshot} {
                      height: 366px;
                      right: 115px;
                      top: 33px;
                      transform: rotateX(6deg) rotateY(-36deg) rotateZ(1deg) skewX(-5deg) skewY(-4deg);
                      width: 483px;

                      /* flip the screenshot when the computer flips so it isn't backwards */
                      &:before {
                          transform: scaleX(${(props) => (props.right ? 1 : -1)});
                      }
                  }
              `
            : css`
                  background-image: url('/static/img/app_landing/phone.svg');
                  transform: scaleX(${(props) => (props.right ? -1 : 1)});

                  ${Screenshot} {
                      height: 412px;
                      right: 267px;
                      top: 29px;
                      transform: rotateX(23deg) rotateY(4deg) rotateZ(-24deg) skewX(7deg) skewY(5deg);
                      width: 233px;

                      /* flip the screenshot when the computer flips so it isn't backwards */
                      &:before {
                          transform: scaleX(${(props) => (props.right ? -1 : 1)});
                      }
                  }
              `};
`
